"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getSelectedLanguageCode = getSelectedLanguageCode;
var _replaceAll = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/replace-all"));
var _convertLanguageCodeToRegionalCode = require("./convert-language-code-to-regional-code");
var _retrieveLanguageCode = require("./retrieve-language-code");
var _constants = require("../constants");
/**
 * Retrieves the current language code from the URL parameter or the document's locale data attribute.
 *
 * @returns {string} - The current language code in a standardized format, or the default language if not found.
 */
function getSelectedLanguageCode() {
  try {
    var _context;
    const lang = (0, _replaceAll.default)(_context = (0, _retrieveLanguageCode.retrieveLanguageCode)()).call(_context, '_', '-');
    return (0, _convertLanguageCodeToRegionalCode.convertLanguageCodeToRegionalCode)(lang);
  } catch (err) {
    return _constants.defaultLanguage;
  }
}